import { Indicator } from "../Indicator";
import { Periodicity } from "../Handbooks/Periodicity";

/**
 * Фактор / значение индикатора<para/>
 * Factor / indicator's value
 */
export class Factor {
  /**
   * Первичный ключ<para/>
   * Primary key
   */
  Id: string = "";
  /**
   * Идентификатор индикатора<para/>
   * Indicator identifier
   */
  IndicatorId: number = 0;
  /**
   * Идентификатор периодичности<para/>
   * Periodicity identifier
   */
  PeriodicityId: number = 0;
  /**
   * Комментарий.
   * В связи с огромным количеством факторов, комментарий не должен быть локализирован 3 отдельными полями
   * <para/>
   * Comment.
   * Due to gianting amount of factors comment should not be localized with 3 fields.
   */
  Comment: string = "";
  /**
   * Значение фактора / показателья/значения индикатора<para/>
   * Value of factor / indicator's value
   */
  Value: number = 0;
  /**
   * Плановое значение фактора / показателья/значения индикатора<para/>
   * Planned value of factor / indicator's value
   */
  PlannedValue: number = 0;
  /**
   * Идентификатор создателя<para/>
   * Creator identifier
   */
  CreatorId: string = "";
  /**
   * Начало периодичности<para/>
   * Periodicity start
   */
  PeriodStart: Date = new Date();
  /**
   * Окончание периодичности<para/>
   * Periodicity end
   */
  PeriodEnd: Date = new Date();
  /**
   * Индикатор<para/>
   * Indicator
   */
  Indicator: Indicator = null;
  /**
   * Периодичность этого фактора<para/>
   * Periodicity of this factor
   */
  Periodicity: Periodicity = null;
  /**
   * Начало периодичности<para/>
   * Periodicity start
   */
  PeriodStartString: string = "";
  /**
   * Окончание периодичности<para/>
   * Periodicity end
   */
  PeriodEndString: string = "";
  /**
   * Идентификаторы регионов<para/>
   * Regions' identifiers
   */
  RegionsIds: Array<number> = [];
  /**
   * Идентификатор региона<para/>
   * Region identifier
   */
  RegionId: number = 0;
  /**
   * Признак возможности редактирования<para/>
   * Sign of editing availability
   */
  isEditable: boolean = false;
}
